export const columnHeader = [
  {
    name: 'Patient Name',
    key: 'PatientName'
  },
  {
    name: 'Encounter',
    key: 'EncounterID'
  },
  {
    name: 'Provider',
    key: 'SchedulingProviderName'
  },
  {
    // name: 'Date of Service',
    name: 'DOS',
    key: 'ServiceStartDate'
  },
  {
    // name: 'Procedure',
    name: 'Code',
    key: 'ProcedureCode'
  },
  {
    name: 'Primary Insurance',
    key: 'PrimaryInsurancePlanName'
  },
  {
    name: 'Secondary Insurance',
    key: 'SecondaryInsurancePlanName'
  },
  {
    name: 'Facility',
    key: 'ServiceLocationName'
  },
  {
    name: 'DXC1',
    key: 'EncounterDiagnosisID1'
  }
]
export const columnHeader2 = [
  {
    name: 'Viol Count',
    key: 'ViolationCount'
  },
  {
    name: 'Enc ID',
    key: 'EncounterID'
  },
  {
    name: 'Patient Name',
    key: 'PatientName'
  },
  {
    name: 'DOS',
    key: 'ServiceStartDate'
  },
  {
    name: 'Scheduling Provider',
    key: 'SchedulingProviderName'
  },
  {
    name: 'Facility',
    key: 'ServiceLocationName'
  },
  {
    name: 'Primary Insurance',
    key: 'PrimaryInsurancePlanName'
  },
  {
    name: 'Secondary Insurance',
    key: 'SecondaryInsurancePlanName'
  },
  {
    name: 'Code',
    key: 'ProcedureCode'
  },
  {
    name: 'Mod',
    key: 'ProcedureModifier1'
  },
  {
    name: 'DXC1',
    key: 'EncounterDiagnosisID1'
  },
  {
    name: 'Total Charge',
    key: 'TotalCharges'
  },
  {
    name: 'Assigned To',
    key: 'AssignedTo'
  },
  {
    name: 'Whats Needed',
    key: 'WhatsNeeded'
  },
  {
    name: 'Scrub Date',
    key: 'created_at'
  },
  {
    name: 'Due Date',
    key: 'DueDate'
  },
]

export const denialHeader = [
  // {
  //   name: 'Flag',
  //   key: 'Flag'
  // },
  {
    name: 'Claim ID',
    key: 'ClaimID'
  },
  {
    name: 'Enc ID',
    key: 'EncID'
  },
  {
    name: 'Patient Name',
    key: 'PatientName'
  },
  {
    name: 'DOS',
    key: 'ServiceStartDate'
  },
  {
    name: 'Scheduling Provider',
    key: 'SchedulingProviderName'
  },
  {
    name: 'Facility',
    key: 'ServiceLocationName'
  },
  {
    name: 'Billed To',
    key: 'BilledTo'
  },
  {
    name: 'Code',
    key: 'ProcedureCode'
  },
  {
    name: 'Mod',
    key: 'Mod'
  },
  {
    name: 'DXC1',
    key: 'EncounterDiagnosisID1'
  },
  {
    name: 'Total Charge',
    key: 'TotalCharge'
  },
  {
    name: 'Balance',
    key: 'Balance'
  },
  {
    name: 'Redenied',
    key: 'Redenied'
  },
  {
    name: 'Adj Code',
    key: 'AdjCode'
  },
  {
    name: 'Remark',
    key: 'Remark'
  },
  {
    name: 'Assigned To',
    key: 'AssignedTo'
  },
  {
    name: `What's Needed`,
    key: 'WhatsNeeded'
  },
  {
    name: 'Denial Date',
    key: 'DenialDate'
  },
  {
    name: 'Due Date',
    key: 'DueDate'
  },
]

export const noResponseHeader = [
  {
    name: 'Claim ID',
    key: 'ClaimID'
  },
  {
    name: 'Enc ID',
    key: 'EncID'
  },
  {
    name: 'Patient Name',
    key: 'PatientName'
  },
  {
    name: 'DOS',
    key: 'ServiceStartDate'
  },
  {
    name: 'Scheduling Provider',
    key: 'SchedulingProviderName'
  },
  {
    name: 'Facility',
    key: 'ServiceLocationName'
  },
  {
    name: 'Billed To',
    key: 'BilledTo'
  },
  {
    name: 'Code',
    key: 'ProcedureCode'
  },
  {
    name: 'Total Charge',
    key: 'TotalCharge'
  },
  {
    name: 'Balance',
    key: 'Balance'
  },
  {
    name: 'Repeat',
    key: 'Repeat'
  },
  {
    name: 'Assigned To',
    key: 'AssignedTo'
  },
  {
    name: `What's Needed`,
    key: 'WhatsNeeded'
  },
  {
    name: 'No Resp Date',
    key: 'NoResponseDate'
  },
  {
    name: 'Due Date',
    key: 'DueDate'
  },
  {
    name: 'Actions',
    key: 'Actions'
  }
]

// No response management dropdown values
export const whatsNeededNoResp = [
  {key: 'AI_Call_In_Progress', value: 'AI Call In Progress'},
  {key: 'cannotContact', value: 'Cannot Contact'},
  {key: 'emailForStatus', value: 'Email for Status'},
  {key: 'eobRequested', value: 'EOB Requested'},
  {key: 'eraReceived', value: 'ERA Received'},
  {key: 'needToCall', value: 'Need to Call'},
  {key: 'paymentReview', value: 'Payment Review'},
  {key: 'pendingAdjudication', value: 'Pending Adjudication'},
  {key: 'portalIssue', value: 'Portal Issue'},
  {key: 'pullFromPortal', value: 'Pull From Portal'},
  {key: 'research', value: 'Research'},
  {key: 'Review_AI_Call', value: 'Review AI Call'},
  {key: 'waitingCallBack', value: 'Waiting Call Back'},
  {key: 'waitingemailReply', value: 'Waiting Email Reply'},
]

export const actionTakenNoResp = [
  {key: 'fax', value: 'Obtained EOB via Fax'},
  {key: 'fixedPostingError', value: 'Fixed Posting Error'},
  {key: 'insTransfer', value: 'Ins Transfer'},
  {key: 'patientBilled', value: 'Patient Billed'},
  {key: 'phone', value: 'Obtained EOB via Phone'},
  {key: 'portal', value: 'Obtained EOB via Portal'},
  {key: 'rebilled', value: 'Rebilled'},
  {key: 'remove', value: 'Remove'},
  {key: 'settled', value: 'Settled'},
  {key: 'voided', value: 'Voided'},
]

export const adjustCodeDenial = [
  {key: 'co', value: 'CO', desc: 'Contractual Obligation'},
  {key: 'oa', value: 'OA', desc: 'Other Adjustment'},
  {key: 'pr', value: 'PR', desc: 'Patient Responsibility'},
  {key: 'pi', value: 'PI', desc: 'Payor Initiated Reduction'},
]

export const pendingWorkedValidationHeader = [
  {
    name: 'Claim ID',
    key: 'ClaimID'
  },
  {
    name: 'Enc ID',
    key: 'EncID'
  },
  {
    name: 'Patient Name',
    key: 'PatientName'
  },
  {
    name: 'DOS',
    key: 'ServiceStartDate'
  },
  {
    name: 'Scheduling Provider',
    key: 'SchedulingProviderName'
  },
  {
    name: 'Facility',
    key: 'ServiceLocationName'
  },
  {
    name: 'Billed To',
    key: 'BilledTo'
  },
  {
    name: 'Code',
    key: 'ProcedureCode'
  },
  {
    name: 'Mod',
    key: 'Mod'
  },
  {
    name: 'DXC1',
    key: 'EncounterDiagnosisID1'
  },
  {
    name: 'Total Charge',
    key: 'TotalCharge'
  },
  {
    name: 'Balance',
    key: 'Balance'
  },
  {
    name: 'Redenied',
    key: 'Redenied'
  },
  {
    name: 'Adj Code',
    key: 'AdjCode'
  },
  {
    name: 'Remark',
    key: 'Remark'
  },
  {
    name: `What's Needed`,
    key: 'WhatsNeeded'
  },
  {
    name: 'Completed By',
    key: 'completedBy'
  },
  {
    name: 'Date Completed',
    key: 'dateCompleted'
  },
  {
    name: 'Action Taken',
    key: 'actionTaken'
  }
]

export const noRespPendingHeader = [
  {
    name: 'Claim ID',
    key: 'ClaimID'
  },
  {
    name: 'Enc ID',
    key: 'EncID'
  },
  {
    name: 'Patient Name',
    key: 'PatientName'
  },
  {
    name: 'DOS',
    key: 'ServiceStartDate'
  },
  {
    name: 'Scheduling Provider',
    key: 'SchedulingProviderName'
  },
  {
    name: 'Facility',
    key: 'ServiceLocationName'
  },
  {
    name: 'Billed To',
    key: 'BilledTo'
  },
  {
    name: 'Code',
    key: 'ProcedureCode'
  },
  {
    name: 'Total Charge',
    key: 'TotalCharge'
  },
  {
    name: 'Balance',
    key: 'Balance'
  },
  {
    name: 'Repeat',
    key: 'repeat'
  },
  {
    name: `What's Needed`,
    key: 'WhatsNeeded'
  },
  {
    name: 'Worked By',
    key: 'workedBy'
  },
  {
    name: 'No Resp Date',
    key: 'noRespDate'
  },
  // {
  //   name: 'Retrieved Date',
  //   key: 'retrievedDate'
  // },
  {
    name: 'Date Completed',
    key: 'dateCompleted'
  },
  // {
  //   name: 'Date Worked',
  //   key: 'dateWorked'
  // },
  {
    name: 'Action Taken',
    key: 'actionTaken'
  }
]

let today = new Date()
let tomorrow = today.setDate(today.getDate() - 1)

export const dueDateData = [
  {label: 'Missing', value: ''},
  {label: 'Late', value: ''},
  {label: 'Today', value: today},
  {label: 'Tomorrow', value: tomorrow},
  {label: 'This Week', value: ''},
  {label: 'Next Week', value: ''},
  {label: 'Future', value: ''},
]
export const redeniedData = ["Yes", "No"]

export const issueTypes = [
  {name: "appealDenied", value: "Appeal Denied"},
  {name: "authorization", value: "Authorization"},
  {name: "cob", value: "COB"},
  {name: "coding", value: "Coding"},
  {name: "inclusive", value: "Coding/Inclusive"},
  {name: "credentialing", value: "Credentialing"},
  {name: "dataEntry", value: "Data Entry"},
  {name: "denialUnclear", value: "Denial Unclear"},
  {name: "documentation", value: "Documentation"},
  {name: "eligibility", value: "Eligibility"},
  {name: "nonCovered", value: "Non-Covered"},
  {name: "paymentIssue", value: "Payment Issue"},
  {name: "pendingAdjudiction", value: "Pending Adjudication"},
  {name: "prescription", value: "Prescription"},
  {name: "provider", value: "Provider"},
  {name: "timelyFiling", value: "Timely Filing"},
]